import { Injectable } from '@angular/core';
import { UserdataService } from './userdata.service';


@Injectable()
export class DesktopDatabaseHelperService {

    // stores the original spaces -> classes -> bundles -> products
    originalSpacesData;

    // stores the original entitlements | dbData -> data -> entities -> entitlements
    originalEntitlementsData

    // stores the original umbrella bundles -> products
    originalUmbrellaData

    // map to store respective data keys
    public DATAKEYS = {
        ENTITLEMENTS: "ENTITLEMENTS",
        SPACES: "SPACES",
        UMBRELLAS: "UMBRELLAS",
        MANIFESTS: "MANIFESTS"
    }

    // map to store flags for ongoing DB operations
    pendingDatabaseOpertions = {
        ENTITLEMENTS: false,
        SPACES: false,
        UMBRELLAS: false,
        MANIFESTS: false
    }

    constructor(
        private userdataService: UserdataService,
    ) { }

    /**
 * Function to fetch original data and return.
 * Return data from memory, else fetch from localstorage -> set in DB and return, else fetch from DB and return.
 * @param dataKey - Collection for which data is to be fetched.
 * @returns original / unmodified data.
 */
    async getOriginalSpacesData() {
        if (this.originalSpacesData) {
            return this.originalSpacesData;
        } else {
            let user = this.userdataService.getLoggedInUser();
            let localStorageKey = this.DATAKEYS.SPACES;
            let localStorageSpacesData = JSON.parse(localStorage.getItem(localStorageKey));
            if (localStorageSpacesData) {
                this.setOriginalSpacesData(localStorageSpacesData, true);
                return localStorageSpacesData;
            } else {
                // uid is passed for GET_UMBRELLAS but is never used.
                let dbData = await DLS_IPCCallers.GET_CLASSES(user.uid);
                console.log('getOriginalSpacesData');
                console.log(dbData);
                this.originalSpacesData = dbData ? dbData : {};
                return this.originalSpacesData;
            }
        }
    }

    /**
     * Function to Store data in DB
     * in case a DB transaction is in progress, try again in 2 secs.
     * @param dataKey - Collection for which data is to be stored
     * @param dataValue - data to be stored
     * @param updateDB - is value to be updated in DB 
     * @returns 
     */
    async setOriginalSpacesData(spacesData, updateDB = false) {
        let localStorageKey = this.DATAKEYS.SPACES;
        localStorage.setItem(localStorageKey, JSON.stringify(spacesData));
        this.originalSpacesData = spacesData;

        if (updateDB) {
            if (this.getPendingDatabaseStatus()) {
                console.log('setOriginalSpacesData timeout');
                setTimeout(() => {
                    this.setOriginalSpacesData(spacesData, true);
                }, 2000)
                return;
            }
            this.pendingDatabaseOpertions[this.DATAKEYS.SPACES] = true;
            await DLS_IPCCallers.SET_CLASSES(spacesData);
            localStorage.removeItem(localStorageKey);
            this.pendingDatabaseOpertions[this.DATAKEYS.SPACES] = false;
        }
    }

    /**
     * Function to fetch original data and return.
     * Return data from memory, else fetch from localstorage -> set in DB and return, else fetch from DB and return.
     * @param dataKey - Collection for which data is to be fetched.
     * @returns original / unmodified data.
     */
    async getOriginalEntitlementsData() {
        if (this.originalEntitlementsData) {
            return this.originalEntitlementsData;
        } else {
            let user = this.userdataService.getLoggedInUser();
            let localStorageKey = this.DATAKEYS.ENTITLEMENTS;
            let localStorageSpacesData = JSON.parse(localStorage.getItem(localStorageKey));
            if (localStorageSpacesData) {
                this.setOriginalEntitlementsData(localStorageSpacesData, true);
                return localStorageSpacesData.entitlementsData;
            } else {
                // uid is passed for GET_UMBRELLAS but is never used.
                let dbData = await DLS_IPCCallers.GET_ENTITLEMENTS(user.uid);
                console.log('getOriginalEntitlementsData');
                console.log(dbData);
                this.originalEntitlementsData = dbData ? dbData : {};
                return this.originalEntitlementsData;
            }
        }
    }

    /**
     * Function to Store data in DB
     * in case a DB transaction is in progress, try again in 2 secs.
     * @param dataKey - Collection for which data is to be stored
     * @param dataValue - data to be stored
     * @param updateDB - is value to be updated in DB 
     * @returns 
     */
    async setOriginalEntitlementsData(entitlementsData, updateDB = false) {
        let localStorageKey = this.DATAKEYS.ENTITLEMENTS;
        localStorage.setItem(localStorageKey, JSON.stringify(entitlementsData));
        this.originalEntitlementsData = entitlementsData.entitlementsData;

        if (updateDB) {
            if (this.getPendingDatabaseStatus()) {
                console.log('setOriginalEntitlementsData timeout');

                setTimeout(() => {
                    this.setOriginalEntitlementsData(entitlementsData, true);
                }, 2000)
                return;
            }
            this.pendingDatabaseOpertions[this.DATAKEYS.ENTITLEMENTS] = true;
            await DLS_IPCCallers.SET_ENTITLEMENTS(entitlementsData);
            localStorage.removeItem(localStorageKey);
            this.pendingDatabaseOpertions[this.DATAKEYS.ENTITLEMENTS] = false;
        }
    }

    /**
     * Function to fetch original data and return.
     * Return data from memory, else fetch from localstorage -> set in DB and return, else fetch from DB and return.
     * @param dataKey - Collection for which data is to be fetched.
     * @returns original / unmodified data.
     */
    async getOriginalUmbrellaData() {
        if (this.originalUmbrellaData) {
            return this.originalUmbrellaData;
        } else {
            let localStorageKey = this.DATAKEYS.UMBRELLAS;
            let localStorageUmbrellaData = JSON.parse(localStorage.getItem(localStorageKey));
            if (localStorageUmbrellaData) {
                this.setOriginalUmbrellaData(localStorageUmbrellaData, true);
                this.originalUmbrellaData = localStorageUmbrellaData ? localStorageUmbrellaData : {};
                return this.originalUmbrellaData;
            } else {
                // uid is passed for GET_UMBRELLAS but is never used.
                let dbData = await DLS_IPCCallers.GET_UMBRELLAS();
                console.log('getOriginalUmbrellaData');
                console.log(dbData);
                this.originalUmbrellaData = dbData ? dbData : {};
                return this.originalUmbrellaData;
            }
        }
    }

    /**
     * Function to Store data in DB
     * in case a DB transaction is in progress, try again in 2 secs.
     * @param dataKey - Collection for which data is to be stored
     * @param dataValue - data to be stored
     * @param updateDB - is value to be updated in DB 
     * @returns 
     */
    async setOriginalUmbrellaData(umbrellaData, updateDB = false) {
        let localStorageKey = this.DATAKEYS.UMBRELLAS;
        localStorage.setItem(localStorageKey, JSON.stringify(umbrellaData));
        this.originalUmbrellaData = umbrellaData;

        if (updateDB) {
            if (this.getPendingDatabaseStatus()) {
                console.log('setOriginalUmbrellaData timeout');
                setTimeout(() => {
                    this.setOriginalUmbrellaData(umbrellaData, true);
                }, 2000)
                return;
            }
            this.pendingDatabaseOpertions[this.DATAKEYS.UMBRELLAS] = true;
            await DLS_IPCCallers.SET_UMBRELLAS(umbrellaData);
            localStorage.removeItem(localStorageKey);
            this.pendingDatabaseOpertions[this.DATAKEYS.UMBRELLAS] = false;
        }
    }

    /**
     * Reset original data
     * @param dataKey - Collection for which data is to be reset
     */
    resetOriginalData(dataKey) {
        let localStorageKey = dataKey;
        localStorage.removeItem(localStorageKey);

        if (dataKey == this.DATAKEYS.ENTITLEMENTS) {
            this.originalEntitlementsData = undefined;
        } else if (dataKey == this.DATAKEYS.SPACES) {
            this.originalSpacesData = undefined;
        } else if (dataKey == this.DATAKEYS.UMBRELLAS) {
            this.originalUmbrellaData = undefined;
        }
    }

    /**
     * Function to check if any DB transaction is in progress or not.
     * @returns true / false
     */
    getPendingDatabaseStatus() {
        return Object.keys(this.pendingDatabaseOpertions).findIndex(key => this.pendingDatabaseOpertions[key]) > -1
    }

    /**
     * Sets the manifests data fetched from server in DB.
     * @param data - Original, partially structured manifests data as fetched from server.
     * Structure of data
     * Array of { 'ebookCode': key, 'data': manifest data as fetched from server }
     */
    async addAllManifestsToDB(data, keepPreviousData = false) {
        let user = this.userdataService.getLoggedInUser();

        localStorage.setItem(this.DATAKEYS.MANIFESTS + '-' + user.uid, JSON.stringify(data));
        if (this.getPendingDatabaseStatus()) {
            setTimeout(() => {
                this.addAllManifestsToDB(data)
            }, 2000)
            return;
        }
        this.pendingDatabaseOpertions[this.DATAKEYS.MANIFESTS] = true;
        await DLS_IPCCallers.SET_MANIFESTS({ data: data, keepPreviousData: keepPreviousData });
        localStorage.removeItem(this.DATAKEYS.MANIFESTS + '-' + user.uid);
        this.pendingDatabaseOpertions[this.DATAKEYS.MANIFESTS] = false;
    }

    /**
     * return from memory, else fetch from localStorage, set in DB and return, else fetch from DB and return.
     * @returns the original / unmodified entitlements
     */
    async getAllManifestsFromDB() {

        let user = this.userdataService.getLoggedInUser();
        let localStorageManifests = JSON.parse(localStorage.getItem(this.DATAKEYS.MANIFESTS + '-' + user.uid));
        if (localStorageManifests) {
            this.addAllManifestsToDB(localStorageManifests);
            return localStorageManifests;
        } else {
            let manifestsData = await DLS_IPCCallers.GET_MANIFESTS();
            return manifestsData;
        }
    }

    /**
    * return from DB the original manifests list.
    * @returns the original / unmodified entitlements
    */
    public async getOldManifestsFromDB() {
        let manifestsData = await DLS_IPCCallers.GET_MANIFESTS();
        return manifestsData;
    }

}